import { z } from 'zod';
import { parseDate } from '../utils/date';
import { uuidSchema } from './common';

/** В правилах диапазонов нужны настоящие даты, без нормализации 31 февраля. */
const visibilityDateSchema = z.string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Ожидается дата в формате гггг-мм-дд')
  .refine((value) => parseDate(value) === value, 'Такой даты не существует');

const dateGroupVisibilityShape = {
  scope: z.enum(['self', 'all']),
  /** null — скрыть все даты вплоть до dateTo включительно. */
  dateFrom: visibilityDateSchema.nullable().default(null),
  dateTo: visibilityDateSchema,
};

export const dateGroupVisibilityCreateSchema = z.object(dateGroupVisibilityShape).refine(
  ({ dateFrom, dateTo }) => dateFrom === null || dateFrom <= dateTo,
  { path: ['dateFrom'], message: 'Начало периода не может быть позже окончания' },
);
export type DateGroupVisibilityCreate = z.infer<typeof dateGroupVisibilityCreateSchema>;

export const dateGroupVisibilityPromoteSchema = z.object({ scope: z.literal('all') }).strict();

export const dateGroupVisibilityRuleSchema = z.object({
  id: uuidSchema,
  ...dateGroupVisibilityShape,
  createdAt: z.string(),
});
export type DateGroupVisibilityRule = z.infer<typeof dateGroupVisibilityRuleSchema>;
